// constants
import { ChartDesignerActionTypes } from './constants';

export interface ChartDesignerActionType<TPayload> {
    type:
    | ChartDesignerActionTypes.CHANGE_CHART_FUNNEL
    | ChartDesignerActionTypes.CHANGE_CHART_GAUGE
    | ChartDesignerActionTypes.CHANGE_CHART_MAP
    | ChartDesignerActionTypes.CHANGE_CHART_PIE
    | ChartDesignerActionTypes.CHANGE_CHART_PICS
    | ChartDesignerActionTypes.CHANGE_CHART_SCATTER
    | ChartDesignerActionTypes.CHANGE_ISSORTING
    | ChartDesignerActionTypes.CHANGE_ISCONDITIONALLY
    | ChartDesignerActionTypes.CHANGE_ISTOPN   
    | ChartDesignerActionTypes.CHANGE_ISALARM
    | ChartDesignerActionTypes.CHANGE_isDrillTrogh
    | ChartDesignerActionTypes.CHANGE_DrillTroghItem    
    | ChartDesignerActionTypes.CHANGE_ISCHANGESHAXES
    | ChartDesignerActionTypes.CHANGE_CHART_GRIDLINE
    | ChartDesignerActionTypes.CHANGE_CHART_TOOLTIP
    | ChartDesignerActionTypes.CHANGE_CHART_LINE
    | ChartDesignerActionTypes.CHANGE_CHART_RANGEMARKER
    | ChartDesignerActionTypes.CHANGE_CHART_LINEAREA      
    | ChartDesignerActionTypes.CHANGE_CHART_WIDGET
    | ChartDesignerActionTypes.CHANGE_CHART_TEXT
    | ChartDesignerActionTypes.CHANGE_ACTIVEKEY_PUBLICSETTINGS
    | ChartDesignerActionTypes.CHANGE_CHART_LEGEND
    | ChartDesignerActionTypes.CHANGE_CHART_PUBLIC
    | ChartDesignerActionTypes.CHANGE_CHART_LABELONCHART
    | ChartDesignerActionTypes.CHANGE_CHART_TABLESTYLE
    | ChartDesignerActionTypes.CHANGE_MAPTYPE
    | ChartDesignerActionTypes.CHANGE_GAUGETYPE
    | ChartDesignerActionTypes.CHANGE_RESET_INITIAL_STATE
    | ChartDesignerActionTypes.CHANGE_CHART_DRILL_STEP    
    | ChartDesignerActionTypes.CHANGE_DRILLVALUE
    | ChartDesignerActionTypes.CHANGE_CHART_DRILL
    | ChartDesignerActionTypes.CHANGE_CHART_DATA
    | ChartDesignerActionTypes.CHANGE_CHARTTYPE
    | ChartDesignerActionTypes.CHANGE_CHARTCOLORPALLET
    | ChartDesignerActionTypes.CHANGE_SEARCH_VALUE
    | ChartDesignerActionTypes.CHANGE_CHARTID
    | ChartDesignerActionTypes.CHANGE_FIELD
    | ChartDesignerActionTypes.CHANGE_BOAD
    | ChartDesignerActionTypes.CHANGE_SHAXES
    | ChartDesignerActionTypes.CHANGE_NEWFIELD    
    | ChartDesignerActionTypes.CHANGE_ADDNEWFIELD
    | ChartDesignerActionTypes.CHANGE_DELETENEWFIELD
    | ChartDesignerActionTypes.CHANGE_SHAXES_AGGREGATION
    | ChartDesignerActionTypes.CHANGE_SHAXES_ISNOTNULLAGREGATION
    |ChartDesignerActionTypes.CHANGE_SHAXES_NONEVALUETYPEAGREGATION
    | ChartDesignerActionTypes.CHANGE_SHAXES_UNIQNAME
    | ChartDesignerActionTypes.CHANGE_BOAD_UNIQNAME    
    | ChartDesignerActionTypes.CHANGE_BOAD_SORT
    | ChartDesignerActionTypes.CHANGE_SHAXES_SORT
    | ChartDesignerActionTypes.CHANGE_BOAD_FILTER
    | ChartDesignerActionTypes.CHANGE_SHAXES_FILTER
    | ChartDesignerActionTypes.CHANGE_CONDITION_FILTER
    | ChartDesignerActionTypes.CHANGE_BOAD_FILTERCRITERIA
    | ChartDesignerActionTypes.CHANGE_SHAXES_FILTERCRITERIA
    | ChartDesignerActionTypes.CHANGE_CONDITION_FILTERCRITERIA
    | ChartDesignerActionTypes.CHANGE_SHAXES_FILTERAGGREGATION
    | ChartDesignerActionTypes.CHANGE_BOAD_FILTERGVARIABLE
    | ChartDesignerActionTypes.CHANGE_CONDITION_FILTERGVARIABLE    
    | ChartDesignerActionTypes.CHANGE_SHAXES_CALCULATETYPE
    | ChartDesignerActionTypes.CHANGE_SHAXES_CHARTTYPE    
    | ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPMODE
    | ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPCOLOR
    | ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPCOLOR2
    | ChartDesignerActionTypes.CHANGE_SHAXES_ISSHOWTOTAL
    | ChartDesignerActionTypes.CHANGE_SHAXES_DESIGN
    | ChartDesignerActionTypes.CHANGE_CONDOTION
    | ChartDesignerActionTypes.CHANGE_GROUPES
    | ChartDesignerActionTypes.CHANGE_TESTAM
    | ChartDesignerActionTypes.CHANGE_SHAXES_CONDITIONALLITY
    | ChartDesignerActionTypes.CHANGE_ALARM
    | ChartDesignerActionTypes.CHANGE_TopN    
    | ChartDesignerActionTypes.CHANGE_TABLE_CONDITIONALLITY
    | ChartDesignerActionTypes.CHANGE_GET_CONDITIONALLITYLIST       
    | ChartDesignerActionTypes.CHANGE_CONDITIONALLITY 
    | ChartDesignerActionTypes.CHANGE_CURRENTSHAXESID         
    | ChartDesignerActionTypes.CHANGE_CURRENTBOADID         
    payload?: TPayload;
}

export const changeChartDataAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_DATA,
    payload: layout,
});

export const changeSearchValueAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SEARCH_VALUE,
    payload: layout,
});

export const changeChartIdAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHARTID,
    payload: layout,
});

export const changeFieldAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_FIELD,
    payload: layout,
});


export const changeBoadAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_BOAD,
    payload: layout,
});

export const changeShaxesAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES,
    payload: layout,
});

export const changeCurrentShaxesIdAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CURRENTSHAXESID,
    payload: layout,
});


export const changeCurrentBoadIdAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CURRENTBOADID,
    payload: layout,
});

export const changeNewFieldAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_NEWFIELD,
    payload: layout,
});

export const changeAddNewFieldAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_ADDNEWFIELD,
    payload: layout,
});

export const changeDeleteNewFieldAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_DELETENEWFIELD,
    payload: layout,
});

export const changeShaxesAggregationAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_AGGREGATION,
    payload: layout,
});

export const changeShaxesIsNotNullAggregationAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_ISNOTNULLAGREGATION,
    payload: layout,
});

export const changeShaxesNoneValueTypeAggregationAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_NONEVALUETYPEAGREGATION,
    payload: layout,
});



export const changeShaxesUniqNameAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_UNIQNAME,
    payload: layout,
});

export const changeBoadUniqNameAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_BOAD_UNIQNAME,
    payload: layout,
});

export const changeIsSortingAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_ISSORTING,
    payload: layout,
});

export const changeIsConditionally = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_ISCONDITIONALLY,
    payload: layout,
});

export const changeIsTopN = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_ISTOPN,
    payload: layout,
});

export const changeIsAlarm = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_ISALARM,
    payload: layout,
});

export const changeIsDrillTrogh = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_isDrillTrogh,
    payload: layout,
});

export const changeDrillTroghItemAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_DrillTroghItem,
    payload: layout,
});

export const changeIsChangeShaxesAction = (): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_ISCHANGESHAXES,
    //payload: layout,
});

export const changeBoadSortAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_BOAD_SORT,
    payload: layout,
});

export const changeShaxesConditionallityAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_CONDITIONALLITY,
    payload: layout,
});

export const changeAlarmAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_ALARM,
    payload: layout,
});

export const changeTopNAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_TopN,
    payload: layout,
});

export const changeTableConditionallityAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_TABLE_CONDITIONALLITY,
    payload: layout,
});

export const changeBoadFilterAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_BOAD_FILTER,
    payload: layout,
});

export const changeShaxesFilterAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_FILTER,
    payload: layout,
});

export const changeConditionFilterAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CONDITION_FILTER,
    payload: layout,
});

export const changeBoadFilterCriteriaAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_BOAD_FILTERCRITERIA,
    payload: layout,
});

export const changeBoadFilterGVariableAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_BOAD_FILTERGVARIABLE,
    payload: layout,
});

export const changeShaxesFilterCriteriaAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_FILTERCRITERIA,
    payload: layout,
});

export const changeShaxesFilterAggregationAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_FILTERAGGREGATION,
    payload: layout,
});

export const changeConditionFilterCriteriaAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CONDITION_FILTERCRITERIA,
    payload: layout,
});

export const changeConditionFilterGVariableAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CONDITION_FILTERGVARIABLE,
    payload: layout,
});

export const changeShaxesSortAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_SORT,
    payload: layout,
});

export const changeShaxesCalculateTypeAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_CALCULATETYPE,
    payload: layout,
});

export const changeShaxesChartTypeAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_CHARTTYPE,
    payload: layout,
});

export const changeShaxesHeatmapModeAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPMODE,
    payload: layout,
});

export const changeShaxesHeatmapColorAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPCOLOR,
    payload: layout,
});

export const changeShaxesHeatmapColor2Action = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPCOLOR2,
    payload: layout,
});

export const changeShaxesIsShowTotalAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_ISSHOWTOTAL,
    payload: layout,
});



export const changeShaxesDesignAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_SHAXES_DESIGN,
    payload: layout,
});

export const changeConditionAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CONDOTION,
    payload: layout,
});

export const changeGroupesAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_GROUPES,
    payload: layout,
});

export const changeChartTypeAction = (chartType: any, isStack: any, isGroup: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHARTTYPE,
    payload: {chartType, isStack, isGroup},
});

export const changeChartColorPalletAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHARTCOLORPALLET,
    payload: layout,
});

export const changeMapTypeChartAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_MAPTYPE,
    payload: layout,
});

export const changeGaugeTypeChartAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_GAUGETYPE,
    payload: layout,
});

export const changeChartDrillAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_DRILL,
    payload: layout,
});

export const changeChartDrillStepAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_DRILL_STEP,
    payload: layout,
});

export const changeDrillValueDesignAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_DRILLVALUE,
    payload: layout,
});


export const changeTestam = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_TESTAM,
    payload: layout,
});

export const resetToInitialStateAction = (): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_RESET_INITIAL_STATE,
    //payload: layout,
});

export const changeActiveKeyPublicSettingsAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_ACTIVEKEY_PUBLICSETTINGS,
    payload: layout,
});

export const changeChartLegendAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_LEGEND,
    payload: layout,
});

export const changeChartPublicAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_PUBLIC,
    payload: layout,
});

export const changeChartLabelOnChartAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_LABELONCHART,
    payload: layout,
});

export const changeChartTableStyleAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_TABLESTYLE,
    payload: layout,
});

export const changeChartTooltipAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_TOOLTIP,
    payload: layout,
});

export const changeChartLineAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_LINE,
    payload: layout,
});

export const changeChartLineRangeKarkerAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_RANGEMARKER,
    payload: layout,
});



export const changeChartWidgetAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_WIDGET,
    payload: layout,
});

export const changeChartTextChartAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_TEXT,
    payload: layout,
});

export const changeChartGaugeAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_GAUGE,
    payload: layout,
});

export const changeChartMapAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_MAP,
    payload: layout,
});

export const changeChartPieAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_PIE,
    payload: layout,
});

export const changeChartPicsAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_PICS,
    payload: layout,
});

export const changeChartScatterAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_SCATTER,
    payload: layout,
});

export const changeChartGridLineAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_GRIDLINE,
    payload: layout,
});

export const changeChartFunnelAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_FUNNEL,
    payload: layout,
});

export const changeChartLineAreaAction = (layout: any): ChartDesignerActionType<any> => ({
    type: ChartDesignerActionTypes.CHANGE_CHART_LINEAREA,
    payload: layout,
});

